import React from 'react';
import { Facebook, Instagram, Youtube, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-white pt-20 pb-10 border-t border-white/10" data-id="element-84">
      <div className="max-w-7xl mx-auto px-6" data-id="element-85">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-86">
          {/* Brand */}
          <div data-id="element-87">
            <h2 className="text-2xl font-serif font-bold tracking-widest mb-6" data-id="element-88">
              MAYBACH
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-6" data-id="element-89">
              Đỉnh cao của sự sang trọng, nghệ thuật chế tác và kỹ thuật ô tô.
              Định nghĩa tiêu chuẩn từ năm 1909.
            </p>
            <div className="flex gap-4" data-id="element-90">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-91">
                <Facebook size={20} data-id="element-92" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-93">
                <Instagram size={20} data-id="element-94" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-95">
                <Youtube size={20} data-id="element-96" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-97">
                <Twitter size={20} data-id="element-98" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-99">
            <h3 className="text-sm font-bold uppercase tracking-widest mb-6" data-id="element-100">
              Các Mẫu Xe
            </h3>
            <ul className="space-y-4 text-gray-400 text-sm" data-id="element-101">
              <li data-id="element-102">
                <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-103">
                  Maybach S-Class
                </a>
              </li>
              <li data-id="element-104">
                <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-105">
                  Maybach GLS
                </a>
              </li>
              <li data-id="element-106">
                <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-107">
                  Maybach EQS SUV
                </a>
              </li>
              <li data-id="element-108">
                <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-109">
                  Xe Concept
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-110">
            <h3 className="text-sm font-bold uppercase tracking-widest mb-6" data-id="element-111">
              Mua Xe
            </h3>
            <ul className="space-y-4 text-gray-400 text-sm" data-id="element-112">
              <li data-id="element-113">
                <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-114">
                  Cấu Hình Xe
                </a>
              </li>
              <li data-id="element-115">
                <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-116">
                  Tìm Đại Lý
                </a>
              </li>
              <li data-id="element-117">
                <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-118">
                  Ưu Đãi Đặc Biệt
                </a>
              </li>
              <li data-id="element-119">
                <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-120">
                  Dịch Vụ Tài Chính
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-121">
            <h3 className="text-sm font-bold uppercase tracking-widest mb-6" data-id="element-122">
              Pháp Lý
            </h3>
            <ul className="space-y-4 text-gray-400 text-sm" data-id="element-123">
              <li data-id="element-124">
                <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-125">
                  Chính Sách Bảo Mật
                </a>
              </li>
              <li data-id="element-126">
                <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-127">
                  Thông Báo Pháp Lý
                </a>
              </li>
              <li data-id="element-128">
                <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-129">
                  Cookies
                </a>
              </li>
              <li data-id="element-130">
                <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-131">
                  Cài Đặt
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-132">
          <p className="text-gray-600 text-xs" data-id="element-133">
            © 2024 Mercedes-Benz Việt Nam. Bảo lưu mọi quyền.
          </p>
          <div className="flex gap-6 text-xs text-gray-600" data-id="element-134">
            <span data-id="element-135">Nhà Cung Cấp</span>
            <span data-id="element-136">Cookies</span>
            <span data-id="element-137">Bảo Mật Dữ Liệu</span>
          </div>
        </div>
      </div>
    </footer>;
}